import React from 'react';
import { ITabItem } from 'components/tab';
import { BaseSidePanel } from 'components/sidePanel';
import ImageNow from 'components/commandpanel/ImageNow/ImageNow';

export type ImageNowSidePanelProps = {
  expIds?: number[];
  onClose?: () => void;
  isOpenInPopup?: boolean;
};
export default function ImageNowSidePanel(props: ImageNowSidePanelProps) {
  const tabItems_: ITabItem[] = [
    {
      content: <ImageNow {...props} />,
      title: 'Image Now',
    },
  ];

  return <BaseSidePanel tabItems={tabItems_} headerTitle={'Image Now'} />;
}
